
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { REPORTS } from '@/constants/constants';
import { Team } from '@run-diffusion/shared';
import { TeamReportEmbedUrlsDataState } from '@/store';

export default Vue.extend({
	name: 'UserUsageReport',
	metaInfo() {
		return {
			title: 'User Usage',
		};
	},
	props: {
		selectedTeam: { type: Object, default: null },
		selectedCompany: { type: Object, default: null },
		defaultTeamMemberEmail: { type: String, default: null },
	},
	data () {
		return {
			// Dashboards
			userUsageDashboardUrl: null,
		};
	},
	watch: {
		selectedTeam: {
			immediate: true,
			async handler (newVal: Team, oldVal: Team) {
				if (newVal !== oldVal) {
					await this.loadTeamReportEmbedUrls({
						team: newVal,
						company: this.selectedCompany,
						teamMemberEmail: this.defaultTeamMemberEmail,
					});
				}
			},
		},
		teamReportEmbedUrlsData: {
			immediate: true,
			handler (newVal: TeamReportEmbedUrlsDataState, oldVal: TeamReportEmbedUrlsDataState) {
				if (newVal !== oldVal) {
					this.userUsageDashboardUrl = this._get(newVal, `dashboards[${REPORTS.DASHBOARDS.USER_USAGE_DASHBOARD}]`)
				}
			},
		},
	},
	computed: {
		...mapState([
			'user',
			'teamReportEmbedUrlsData',
			'teamReportEmbedUrlsDataLoading',
		]),
	},
	methods: {
		...mapActions([
			'loadTeamReportEmbedUrls',
		]),
	},
});
